import { TestBuy } from "@coworker/types/lib/testbuy";
import styled from "styled-components";
import { useUID } from "../../../core/auth/useLoggedInUser";
import { allCriteriaOk } from "../CommonComponents/article.helpers";
import { TestBuyItem } from "./TestBuyListItem";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { FixaWindow } from "@coworker/reusable/helpers/devices";

const ListWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  border-top: 1px solid var(--grey200);
`;

const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid var(--grey200);
  height: 92px;
  box-sizing: border-box;
  padding: 0px 24px;
  width: 100%;
  &:last-child {
    border-bottom: none;
  }
`;

const SkeletonTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  height: 48px;
  margin-left: 16px;
  width: 100%;
  @media screen and (min-width: 1000px) {
    width: 300px;
  }
`;

const SkeletonStatus = styled(FixaSkeleton)`
  flex-shrink: 0;
`;

interface TestBuyListProps {
  testbuys: TestBuy[] | undefined;
  loading: boolean;
}

export function TestBuyList({ testbuys, loading }: TestBuyListProps) {
  const uid = useUID();
  const sortedTestbuys = [...(testbuys ?? [])].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  if (loading)
    return (
      <div>
        {[...Array(6)].map((_, i) => (
          <SkeletonWrapper key={i}>
            <SkeletonStatus height="48px" width="48px" />
            <SkeletonTextWrapper>
              <FixaSkeleton height="19px" />
              <FixaSkeleton height="19px" />
            </SkeletonTextWrapper>
          </SkeletonWrapper>
        ))}
      </div>
    );

  return (
    <ListWrapper>
      {sortedTestbuys?.map((testbuy) => (
        <TestBuyItem
          key={testbuy.id}
          id={testbuy.id}
          area={testbuy.area}
          areaNew={testbuy.areaNew}
          startDate={testbuy.createdAt}
          numberOfArticles={testbuy.numberOfArticles}
          customName={testbuy.customName}
          isMine={
            testbuy.assignedTo === uid && testbuy.status === "IN_PROGRESS"
          }
          isClosed={testbuy.status === "CLOSED"}
          reasonForClosing={testbuy.closeReason || ""}
          numberOfSucceededArticles={
            testbuy.articles?.filter((art) => allCriteriaOk(art.criteria))
              .length ?? 0
          }
          testbuyTasks={testbuy.tasks}
        />
      ))}
    </ListWrapper>
  );
}
